import { datadogRum } from '@datadog/browser-rum';
import mixpanel from 'mixpanel-browser';

import TourDictionary from '../utils/TourDictionary';

export const getTourViewed = (tourID: string) => {
  const viewed = localStorage.getItem('tour_' + tourID + '_viewed');

  if (viewed) {
    return true;
  } else {
    return false;
  }
};

export const getTour = (tourID: string) => {
  const relevantTour = TourDictionary[tourID];

  return relevantTour;
};

export const setTourViewed = (tourID: string) => {
  if (getTourViewed(tourID)) {
    return;
  }

  datadogRum.addAction('tour_' + tourID + '_viewed', {});

  const relevantTour = getTour(tourID);
  if (relevantTour && relevantTour.mixPanelEventName) {
    mixpanel.track(relevantTour.mixPanelEventName);
  }

  localStorage.setItem('tour_' + tourID + '_viewed', 'true');
};
